export enum WebhookEndpointsTableActionType {
  ChangeSortingType = 'webhookEndpointsTable/changeSortingType',
  ResetState = 'webhookEndpointsTable/resetState',
}
